import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const KYC_BASIC_INTRODUCTION = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
}, 'KYC_BASIC_INTRODUCTION')

// ------------------------------------
// Actions
// ------------------------------------
export function init() {
  return (dispatch) => {
    dispatch(callAPI({
      dispatch: dispatch,
      endpoint: 'test.json',
      requestAction: KYC_BASIC_INTRODUCTION.INIT_REQUEST,
      successAction: KYC_BASIC_INTRODUCTION.INIT_SUCCESS,
      success: function(result) {}
    }))
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [KYC_BASIC_INTRODUCTION.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [KYC_BASIC_INTRODUCTION.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'kycBasicIntroduction',
    reducerMap: {
      kycBasicIntroductionState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
